var map = {
	"./Caretta/Screenshot 2025-10-15 135312.png": 727,
	"./Havelsan/Screenshot 2025-10-15 134702.png": 759,
	"./Insider/image.png": 401,
	"./TAI (Turkish Aerospace Industries)/Screenshot 2025-10-15 134812.png": 541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 687;